import Component from '../../../lib/component'
import template from './WXbase-control.html'
import './WXbase-control.scss'

let config={
	template:template,
	actions:{
		focus(){
			this.el.find('.bottom-submit').hide();
			this.el.find('.auto-select-component').css({'top':'-50px'})
			this.el.find('.refresh').length>0?this.el.find('.refresh').css({'position':'relative','top':'-50px'}):'';
			this.el.find('.wx-control-render').css('overflow','hidden');
		},
		blur(){
			this.el.find('.bottom-submit').show();
			this.el.find('.auto-select-component').css({'top':'0px'})
			this.el.find('.refresh').length>0?this.el.find('.refresh').css({'position':'relative','top':'0px'}):'';
			this.el.find('.wx-control-render').css('overflow','auto');
		}
	},
	binds:[
		{
			event: 'click',
			selector: '.submit',
			callback: function(){
				this.events.changeWXValue(this.data);
			}
		},
		{
			event:'click',
			selector:'.cancel',
			callback:function(){
				this.events.destoryControl();
			}
		}
	],
	afterRender(){
		this.el.find('.wx-control-render').append($(this.data.controlHtml));
		this.el.closest('.weui-tab').find('.weui-tabbar').css('display','none');
		let screen_h = document.documentElement.clientHeight;
		let last_h;
		let el=this.el.closest('.wxControl-wrap');
		//  通过window的onresize事件监控虚拟键盘的弹起过程
		window.onresize = function () {
			let cur_h = document.documentElement.clientHeight;
			if(!last_h){
				last_h=cur_h
			}
			//输入键盘弹出
			if(last_h>cur_h){
				if (screen_h === cur_h) {
					el.css('position', 'static');
					last_h='';
				}
			}else if(last_h<cur_h){
				//  过当前页面高度和全局的初始高度比较判断键盘是否在弹起或者消失的过程中
				if (screen_h === cur_h) {
					el.css({'position':'fixed','bottom':'0'});
					last_h='';
				}
			}
		}
		setTimeout(()=>{
			if(this.el.find('.auto-select-text').length>0){
				this.el.find('.auto-select-text').bind('focus',()=>{
					this.actions.focus();
				})
				this.el.find('.auto-select-text').bind('blur',()=>{
					setTimeout(()=>{
						if(this.el.find('.popup').css('display')!='none'){
							return;
						}
						this.actions.blur();
					})
				})
				this.el.find('.popup').bind('click',()=>{
					this.actions.blur();
				})
			}
			if(this.el.find('input').length>0){
				el.bind('focus',function(){
					el.css('position','static');
					// el.height($(window).height()+'px');
				}).bind('blur',function(){
					el.css({'position':'fixed','bottom':'0'});
					//或者$('#viewport').height('auto');
				});
			}
		})
	},
	beforeDestory(){
		this.el.off();
	}
}
let WxBaseControl = Component.extend(config)
export default WxBaseControl


// WEBPACK FOOTER //
// app/components/form/WXbase-control/WXbase-control.js